'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
	processInclude(require('./search/search'));
	processInclude(require('./components/carouselPreviewImages'));
	processInclude(require('./search/searchRefineBar'));
	processInclude(require('./search/priceSlider'));
	processInclude(require('./search/customAttributeSlider'));
});
